import { AccountInfo } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { AppToken } from 'App';
import { ReactNode, useContext, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { logout } from '../utils/apiHelper';

export function SessionProvider({
  children,
  account,
}: {
  children: ReactNode;
  account: AccountInfo | null;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef<NodeJS.Timeout>();
  const { instance } = useMsal();
  const { authorizedToken } = JSON.parse(useContext(AppToken));
  const logoutUrl = `https://login.microsoftonline.com/${account?.tenantId}`;

  useEffect(() => {
    if (exemptedRoutes.includes(location.pathname)) return;
    const handleWindowEvents = () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        //Perform whatever logic you want in here, clear localStorage and log user out, show a popup modal or just navigate to another page
        logout(authorizedToken).then(() => {
          instance.logoutRedirect({
            authority: logoutUrl,
            postLogoutRedirectUri: '/',
          });
        });
        navigate('/');
      }, 900000);
    };

    // listen for specific window events to ensure user is still active
    window.addEventListener('mousemove', handleWindowEvents);
    window.addEventListener('keydown', handleWindowEvents);
    window.addEventListener('click', handleWindowEvents);
    window.addEventListener('scroll', handleWindowEvents);

    handleWindowEvents();

    //cleanup function
    return () => {
      window.removeEventListener('mousemove', handleWindowEvents);
      window.removeEventListener('keydown', handleWindowEvents);
      window.removeEventListener('click', handleWindowEvents);
      window.removeEventListener('scroll', handleWindowEvents);
    };
  }, [navigate, location.pathname]);

  return <>{children}</>;
}

const exemptedRoutes = ['/signIn'];
